import { ICloseCross } from "@/shared/interfaces/ReUsedComponentsProps";

import "./CloseCross.scss";

export default function CloseCross({ onClick }: ICloseCross) {
    return <button className='drawer_cross_logo' onClick={onClick} />;
}
